













































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import _ from "lodash";
import moment from "moment";
import MyList from "@/mixins/list";

import SelectStadium from "@/components/selectstadium.vue";

import Add from "./add.vue";
import Edit from "./edit.vue";

import Detail from "./detail.vue";
import record from "@/views/agreement/record.vue";

@Component({
  components: {
    SelectStadium,
    Add,
    Edit,
    Detail
  }
})
export default class extends Mixins(MyList) {
  type = "0";

  dispatchType = "oplatformapps/weapps";

  detailVisible = false;

  appid = "";
  qrcode ="";
  auth = 0;
  icp =0;

  // 操作搜索栏的展开和折叠
  isFlag = false;

  codeTypeArr = [
    { value: "1", name: "统一社会信用代码" },
    { value: "2", name: "组织机构代码" },
    { value: "3", name: "营业执照注册号" }
  ];

  columns0: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "场馆", scopedSlots: { customRender: "stadium_name" } },
    { title: "企业名", dataIndex: "name" },
    { title: "企业代码", dataIndex: "code" },
    { title: "企业代码类型", scopedSlots: { customRender: "code_type" } },
    { title: "法人微信号", dataIndex: "legal_persona_wechat" },
    { title: "法人姓名", dataIndex: "legal_persona_name" },
    { title: "第三方联系电话", dataIndex: "component_phone" },
    { title: "状态码", dataIndex: "errcode" },
    { title: "状态消息", dataIndex: "errmsg" },
    { title: "小程序", scopedSlots: { customRender: "appid" } },
    { title: "当前版本号", dataIndex: "ver" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  columns1: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "场馆", scopedSlots: { customRender: "stadium_name" } },
    { title: "个人用户名字", dataIndex: "idname" },
    { title: "个人用户微信号", dataIndex: "wxuser" },
    { title: "第三方联系电话", dataIndex: "component_phone" },
    { title: "状态码", dataIndex: "errcode" },
    { title: "状态信息", dataIndex: "errmsg" },
    { title: "任务id", dataIndex: "taskid" },
    { title: "认证url", scopedSlots: { customRender: "authorize_url" } },
    { title: "小程序", scopedSlots: { customRender: "appid" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  columns2: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "场馆", scopedSlots: { customRender: "stadium_name" } },
    { title: "小程序名称", dataIndex: "name" },
    { title: "openid", dataIndex: "openid" },
    { title: "状态码", dataIndex: "errcode" },
    { title: "状态信息", dataIndex: "errmsg" },
    { title: "唯一标识符", dataIndex: "unique_id" },
    { title: "认证url", scopedSlots: { customRender: "authorize_url" } },
    { title: "小程序", scopedSlots: { customRender: "appid" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  columns: any = this.columns0;

  @Watch("$route")
  watchRoute(to: any, from: any) {
    if (!_.isEqual(from, to)) {
      if (to.path !== from.path) {
        this.searchData = {};

        this.form.setFieldsValue({
          stadium_id: ""
        });
      }

      this.type = to.path.replace("/oplatform/weapp", "");

      if (this.type == "1") {
        this.columns = this.columns1;
      } else if (this.type == "2") {
        this.columns = this.columns2;
      } else {
        this.columns = this.columns0;
      }

      this.loadData({
        type: this.type
      });
    }
  }

  mounted() {
    this.type = this.$route.path.replace("/oplatform/weapp", "");

    if (this.type == "1") {
      this.columns = this.columns1;
    } else if (this.type == "2") {
      this.columns = this.columns2;
    } else {
      this.columns = this.columns0;
    }

    this.loadData({
      type: this.type
    });
  }

  showDetail(id: string,qr:string,auth:number,icp:number) {
    this.appid = id;
    this.qrcode=qr;
    if(this.type!="0"){
      this.auth=1;
      this.icp=1;
    }else {
      this.auth=auth;
      this.icp=icp;
    }
    this.detailVisible = true;
  }

  closeDetail() {
    this.detailVisible = false;
  }

  async searchStatus(id: number) {
    // console.log(id);
    const id1 = id;

    const res = await this.$store.dispatch("oplatformapps/searchStatus", { id: id1 });
    if (res && res.Message && res.Message == "success") {
      this.$info({
        title: "",
        content: res.Data
      });
    } else {
      this.$info({
        title: "",
        content: res.Message
      });
    }
  }

  async delRecord(id:number){
      this.$confirm({
        title: "确认信息",
        content: "确定要删除吗？",
        onOk: async () => {
          this.confirmLoading = true;
          const res = await this.$store.dispatch("oplatformapps/delweapp", {
            id
          });
          if (res && res.Message && res.Message === "success") {
            this.$message.success(res.Message);
            this.loadData({
              type: this.type
            });
          } else {
            this.$message.error(res.Message);
          }
          this.confirmLoading = false;
        }
      });
  }
}
